/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AgeLimit from './AgeLimit/index'
import AnnualDeductible from './AnnualDeductible/index'
import CoordinationOfBenefits from './CoordinationOfBenefits/index'
import DependentAge from './DependentAge/index'
import Downpayment from './Downpayment/index'
import DownpaymentPercentageBase from './DownpaymentPercentageBase/index'
import InProgressCoverage from './InProgressCoverage/index'
import LifetimeCoverage from './LifetimeCoverage/index'
import React from 'react'
import ReimbursementRate from './ReimbursementRate/index'
import WaitingPeriod from './WaitingPeriod/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/OrthodonticCoverage/OrthoCoverage/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<LifetimeCoverage
  viewPath={`${viewPath}/LifetimeCoverage`}
/>
<DependentAge
  viewPath={`${viewPath}/DependentAge`}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal1}`}
>
<ReimbursementRate
  viewPath={`${viewPath}/ReimbursementRate`}
/>
<AgeLimit
  viewPath={`${viewPath}/AgeLimit`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal2}`}
>
<AnnualDeductible
  viewPath={`${viewPath}/AnnualDeductible`}
/>
<WaitingPeriod
  viewPath={`${viewPath}/WaitingPeriod`}
/>
</div>
<Downpayment
  viewPath={`${viewPath}/Downpayment`}
/>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal3}`}
>
<DownpaymentPercentageBase
  viewPath={`${viewPath}/DownpaymentPercentageBase`}
/>
<CoordinationOfBenefits
  viewPath={`${viewPath}/CoordinationOfBenefits`}
/>
</div>
<InProgressCoverage
  viewPath={`${viewPath}/InProgressCoverage`}
/>
</div>
{children}
</React.Fragment>)
}